import React from "react";
import { Link } from "gatsby";

const DigitalCase = () => (
  <section className="section--digitalcase">
    <h4
      style={{
        marginTop: 0,
        marginBottom: "1em",
        fontWeight: "600",
      }}
    >
      <p class="text-red">
        Stimați justițiabili,
        <br />
        Pentru accesul la documentele în format electronic din dosarele aflate
        pe rolul Curţii de Apel Timişoara și a instanțelor din raza sa, se pot
        folosi aplicaţiile
        <a
          target="_blank"
          href="https://doc.curteapeltimisoara.ro/autentificare"
        >
          Dosarul Electronic
        </a>{" "}
        şi
        <a target="_blank" href="https://den.just.ro">
          Dosarul Electronic Naţional
        </a>
        . Mai multe informații privind accesul online la dosar găsiți
        <a target="_blank" href="/dosarulelectronic">
          aici
        </a>
        .
      </p>
    </h4>
  </section>
);

export default DigitalCase;
